export default __webpack_public_path__ + "static/6-55e962ff38a2753efe90c131fe7e3fb8.svg";